import type { IconData } from '@stacksjs/iconify-core'

export const diamond1: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"m44.88 18.016l-5.352-9.49A3 3 0 0 0 36.915 7h-25.83a3 3 0 0 0-2.612 1.526l-5.353 9.49a3 3 0 0 0 .491 3.595l18.975 18.975a2 2 0 0 0 2.828 0L44.39 21.61a3 3 0 0 0 .492-3.595Z\"/><path d=\"m18.773 7l-2.956 11.74a4 4 0 0 0 .167 2.466l8.008 19.966h.017\"/><path d=\"m29.227 7l2.955 11.74a4 4 0 0 1-.166 2.466l-8.008 19.966M3 20h42\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default diamond1
